import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Icon } from "./ui";
import { t } from "../i18n";
import { listenForDeepLinks } from "../platform/device";
import { useEffect } from "react";

export function AppShell() {
  const navigate = useNavigate();
  useEffect(() => {
    let remove: (() => Promise<void>) | undefined;
    void listenForDeepLinks((path) => navigate(path)).then((h) => {
      remove = () => h.remove();
    });
    return () => {
      void remove?.();
    };
  }, [navigate]);
  return (
    <div className="app-shell">
      <main className="app-main">
        <Outlet />
      </main>
      <nav className="bottom-nav" aria-label="Primary navigation">
        <NavItem to="/" icon="spark" label={t.nav.home} />
        <NavItem to="/explore" icon="search" label={t.nav.explore} />
        <NavItem to="/plans" icon="calendar" label={t.nav.plans} />
        <NavItem to="/profile" icon="user" label={t.nav.profile} />
      </nav>
    </div>
  );
}
function NavItem({
  to,
  icon,
  label,
}: {
  to: string;
  icon: "spark" | "search" | "calendar" | "user";
  label: string;
}) {
  return (
    <NavLink
      to={to}
      end={to === "/"}
      className={({ isActive }) =>
        `bottom-nav__item ${isActive ? "active" : ""}`
      }
    >
      <Icon name={icon} />
      <span>{label}</span>
    </NavLink>
  );
}
